import { render, staticRenderFns } from "./hardware-list.vue?vue&type=template&id=2bec15a0&"
import script from "./hardware-list.vue?vue&type=script&lang=js&"
export * from "./hardware-list.vue?vue&type=script&lang=js&"
import style0 from "./hardware-list.vue?vue&type=style&index=0&lang=scss&module=true&"
import style1 from "./hardware-list.vue?vue&type=style&index=1&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports